module.exports = __webpack_public_path__ + "static/img/bcg.bc394e36.webp";